import {Accordion, styled} from '@mui/material';

export const StyledAccordion = styled(Accordion)`
	border: none;
	box-shadow: none;
	margin: 0;
	padding: 16px;
	background-color: transparent;

	&::before {
		display: none;
	}

	&:not(:first-of-type) {
		border-top: 1px solid ${({theme}) => theme.palette.divider};
	}

	.MuiAccordionSummary-root {
		min-height: auto;
		gap: 8px;
		padding: 0;

		${({theme}) => theme.breakpoints.down('sm')} {
			align-items: end;
		}
	}

	.MuiAccordionSummary-root > div.MuiAccordionSummary-content {
		margin: 0;
		justify-content: space-between;
	}
`;
